import { render, staticRenderFns } from "./DesktopQrCode.vue?vue&type=template&id=54b4750f"
import script from "./DesktopQrCode.vue?vue&type=script&lang=ts"
export * from "./DesktopQrCode.vue?vue&type=script&lang=ts"
import style0 from "./DesktopQrCode.vue?vue&type=style&index=0&id=54b4750f&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports